import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { ShiftEntity } from './ShiftEntity'

export class AcquireShiftEntity {
  driver?: DriverEntity
  shift?: ShiftEntity
  skipShiftSizeCheck?: boolean
}
